import { Component, type ReactNode } from 'react'

interface State { hasError: boolean }

export default class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: unknown) {
    console.error('constellation flicker:', error)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-void-950 flex items-center justify-center px-6 text-center">
          <div>
            <div className="text-6xl mb-6">🌠</div>
            <h1 className="font-display text-2xl font-bold text-slate-100 mb-3">The constellation flickered</h1>
            <p className="text-sm text-slate-400 mb-8 max-w-sm mx-auto">
              Something unexpected happened in the sky. Your family data is safe — reload to redraw the stars.
            </p>
            <button onClick={() => window.location.reload()} className="btn-gold">Redraw the sky</button>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}
